import styled from 'styled-components';

export default styled.div`
    padding-left: 12px;
    padding-right: 12px;

    margin-bottom: 12px;
`;
